module.exports = __webpack_public_path__ + "mapovate-logo.0ac4e8db46949899865cadfa470792dd.png";